import React from 'react';
import { Grid } from '@mui/material';
import styles from './founding-membership.module.scss';
import { BetaTesterImg } from '../../../../assets/images';
import WhyJoin from './why-join.component';
import adopterIcon from '../../../../assets/images/adopter.png';
import testerIcon from '../../../../assets/images/tester.png';
import gameCoinsIcon from '../../../../assets/images/gameCoins.png';
import linkIcon from '../../../../assets/images/RefLink.png';
import moreCoinIcon from '../../../../assets/images/Coins.png';
import aiCoinIcon from '../../../../assets/images/AIcoin.png';
import nftIcon from '../../../../assets/images/Nfts.png';
import futureIcon from '../../../../assets/images/ShapeFuture.png';
import birdclock from '../../../../assets/images/BirdClock.png';
import starcoin from '../../../../assets/images/StarCoin.png';
import handstar from '../../../../assets/images/StarsHand.png';
import boxsearch from '../../../../assets/images/CardSearch.png';
import airdrop from '../../../../assets/images/AirDrop.png';

import foundingmembersIcon from '../../../../assets/images/Foundingmembers.png';
import betaTestersTcon from '../../../../assets/images/betaTester.png';
import earlyAdoptersIcon from '../../../../assets/images/Earlyadopters.png';
import getGameCoinsIcon from '../../../../assets/images/GetGameCoins.png';
import firstWaveIcon from '../../../../assets/images/First_Wave.png';
import groundFloorOpportunityIcon from '../../../../assets/images/Ground_FloorOpportunity.png';
import vipnftIcon from '../../../../assets/images/VIP_NFT.png';
import quickieMemeCoinAirdropIcon from '../../../../assets/images/QuickieMemeCoinAirdrop.png';
import preBuildYourFollowersIcon from '../../../../assets/images/PreBuildYourFollowers.png';

const whyJoinData = [
  {
    icon: foundingmembersIcon,
    title: 'Founding Members',
    desc: 'Founding Member VIP Badge for the first 10,000 verified members.',
    gradient: 'linear-gradient(to right, #FFD9A8, #FF8379)',
  },
  {
    icon: betaTestersTcon,
    title: 'Beta Testers',
    desc: 'Beta Tester VIP Badge for the next 40,000 verified members.',
    gradient: 'linear-gradient(to right, #F3FFA8, #4AC857)',
  },
  {
    icon: earlyAdoptersIcon,
    title: 'Early Adopters',
    desc: 'Early Adopter VIP Badge for the next 100,000 verified members.',
    gradient: 'linear-gradient(to right, #A8FFEF, #798EFF)',
  },
  {
    icon: getGameCoinsIcon,
    title: 'Get Referral Points',
    desc: 'Earn Referral Points just for signing up.',
  },
  {
    icon: firstWaveIcon,
    title: 'First Wave',
    desc: 'Be part of the First Wave of Web3 User Experience.',
    gradient: 'linear-gradient(to right, #FFCC48, #D479FF)',
  },
  {
    icon: groundFloorOpportunityIcon,
    title: 'Ground Floor Opportunity',
    desc: 'Potential Upside Potential as an early Web3 Creator.',
    gradient: 'linear-gradient(to right, #FFA8C7, #FF7979)',
  },
  {
    icon: vipnftIcon,
    title: 'VIP NFT’s',
    desc: 'Your VIP Badges converts into VIP NFT’s.',
    gradient: 'linear-gradient(to right, #5B94D6, #2FD8FD)',
  },

  {
    icon: quickieMemeCoinAirdropIcon,
    title: 'Quickie Meme Coin Airdrop',
    desc: 'Reserved for VIP Founding Members, Beta Testers and Early Adopters!',
    gradient: 'linear-gradient(to right, #BFA8FF, #FF79E2)',
  },
  {
    icon: preBuildYourFollowersIcon,
    title: 'Pre-Build Your Followers',
    desc: 'QuickCam SocialFi Platform.',
    gradient: 'linear-gradient(to right, #0055D5, #CB70EB)',
  },
];

const FoundingMembership: React.FC = () => {
  return (
    <section className={styles.container} id="founding-membership">
      <div className={styles.contentWrapper}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={7}>
            <h2>Be a QuickCam VIP!</h2>
            <h3>Founding Members, Beta Testers & Early Adopters!</h3>
            <div className={styles.benefitsList}>
              <ul>
                <li>Free Membership</li>
                <li>Get Early Access to QuickCam app</li>
                <li>
                  Members Only Access to Quickie and Speedy Community Meme Coin
                  Pre-Sales!
                </li>
                <li>First 10,000 Members are VIP Founding Members</li>
                <li>Next 40,000 Members are VIP Beta Testers</li>
                <li>Next 100,000 Members are VIP Early Adopters</li>
                <li>600,000,000 Total Quickie Community Meme Coins Reserved</li>
                <li>Earn VIP Badges That Convert Into VIP NFTs</li>
                <li>
                  Catch the QuickCam VIP Wave Before QuickCam Goes Mainstream!
                </li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} md={5}>
            <div className={styles.badgeContainer}>
              <img
                src={BetaTesterImg}
                alt="Founding Member Beta Tester Badge"
                className={styles.badgeImage}
              />
            </div>
          </Grid>
        </Grid>
        <WhyJoin data={whyJoinData} />
      </div>
    </section>
  );
};

export default FoundingMembership;
